import { render, staticRenderFns } from "./AdminQuestion_edit.vue?vue&type=template&id=609e7bb9&"
import script from "./AdminQuestion_edit.vue?vue&type=script&lang=js&"
export * from "./AdminQuestion_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports